import { colors } from 'ic-snacks'
import styled from '@emotion/styled'
import { type LocalNavTheme } from './nav.types'

export const BaseText = styled.span<{ theme?: LocalNavTheme }>`
  color: ${({ theme }) => (!theme.inverted ? colors.GRAY_13 : colors.WHITE)};
`

export const NavLinkText = styled(BaseText)`
  font-size: 14px;
  line-height: 19px;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const NavLinkSubText = styled(BaseText)`
  color: ${({ theme }) => (!theme.inverted ? colors.GRAY_46 : colors.GRAY_74)};
  font-size: 12px;
  line-height: 17px;
`

export const NavHeader = styled(BaseText)`
  font-size: 18px;
  line-height: 24px;
  height: 60px;
  font-weight: 400;
  colors: 1px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => (!theme.inverted ? colors.GRAY_93 : colors.GRAY_13)};
`

export const NavFooter = styled(BaseText)`
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`
